module.exports = __webpack_public_path__ + "static/media/email-verification-image.7ac6fa3d.png";